module.exports = __webpack_public_path__ + "static/media/Now available on Play Store & App Store.0095a717.png";